import { Link } from 'react-router-dom'

export default function Logo() {
	return (
		<Link className="navbar-brand p-0" to="/">
			<img src="assets/image/logo-img.png" alt="logo-img" className="img-fluid" />
		</Link>
	)
}
